import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { MenteeGroupData } from '../../providers/mentee-group-data'
import { ViewMenteeSadhanaPage } from '../view-mentee-sadhana/view-mentee-sadhana';
import { GlobalVariable } from '../../global'
import { AlertController } from 'ionic-angular';
/**
 * Generated class for the MenteeListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-mentee-list',
  templateUrl: 'mentee-list.html',
})
export class MenteeListPage {
  groupname: any;
  mentees: any
  mentors: any
  groupid: any;
  constructor(public navCtrl: NavController, public alertCtrl: AlertController, public navParams: NavParams, private menteeGroupData: MenteeGroupData) {
    this.groupid = navParams.get("groupid");
    this.groupname = navParams.get("groupname");
    if (this.groupid) {
      this.getMenteeList(this.groupid)
    }
  }
  items = [
    'Pokémon Yellow',
    'Super Metroid',
    'Mega Man X',
    'The Legend of Zelda',
    'Pac-Man',
    'Super Mario World',
    'Street Fighter II',
    'Half Life',
    'Final Fantasy VII',
    'Star Fox',
    'Tetris',
    'Donkey Kong III',
    'GoldenEye 007',
    'Doom',
    'Fallout',
    'GTA',
    'Halo'
  ];
  ionViewDidLoad() {
    console.log('ionViewDidLoad MenteeListPage');
  }

  getMenteeList(groupid) {
    this.menteeGroupData.getMenteeList(groupid).subscribe(
      res => {
        res['data'].map(item => {
          if (item.sadhanasummary >= GlobalVariable.GREEN) {
            item.color = 'primary'
          } else if (item.sadhanasummary == GlobalVariable.RED) {
            item.color = 'danger'
          } else {
            item.color = 'orange'
          }
        })
        this.mentees = res['data'].filter(p => p.usertypename === 'Mentee');
        this.mentors = res['data'].filter(p => p.usertypename === 'Mentor')
      },
      err => {
        this.presentAlert('error', 'Something went wrong, try again')
      }
    )
  }

  onClickOnView(item) {

    this.navCtrl.push(ViewMenteeSadhanaPage, {
      menteeuserid: item.userid,
      menteeusername: item.surname + ' ' + item.forename,
      activityname: item.activityname
    })
  }

  presentAlert(title, msg) {

    let alert = this.alertCtrl.create({
      title: title,
      subTitle: msg,
      buttons: [{
        text: 'Dismiss',
      }],
    });
    alert.present();
  }

  deleteMentee(item) {
    const alert = this.alertCtrl.create({
      message: 'Are you sure to Delete?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            console.log('Confirm Cancel: blah');
          }
        }, {
          text: 'Delete',
          handler: () => {
            this.menteeGroupData.deleteMentee(item).subscribe(
              res => {
                this.getMenteeList(this.groupid)
                this.presentAlert('Success', 'Mentee has been removed successfully')
              }
            )
          }
        }
      ]
    });

    alert.present();

  }
}



// WEBPACK FOOTER //
// ./src/pages/mentee-list/mentee-list.ts